<template>
  <modal ref="modal" @close="onClose">
    <template slot="title">WEB公開</template>
    <template slot="name">WEB上に公開（今月残り {{ limitedRemainingCount }}/{{ maxCount }}）</template>
    <template slot="input">
      <div class="input-wrapper">
        <label>
          <input
            type="checkbox"
            :checked="flgSearchIndex"
            v-model="flgSearchIndex"
          />
          検索結果に表示
        </label>
      </div>
    </template>
    <template slot="submit">
      <button v-if="limitedRemainingCount > 0 && !isLoading" type="button" @click="onSubmit" class="submit normal-btn">送信</button>
      <button v-else type="button" disabled class="submit normal-btn">送信</button>
    </template>
  </modal>
</template>

<script>
import base from '@/components/Content/Check/ContentCheckBase'
import modal from '@/components/Util/Modal'

export default {
  name: 'publish-web',
  mixins: [ base ],
  data () {
    return {
      rawHTML: '',
      mobileCSS: '',
      email: '',
      maxCount: 0,
      currentCount: 0,
      isLoading: false,
      flgSearchIndex: false,
    }
  },
  components: {
    modal
  },
  created () {
    this.initRateLimit()
  },
  methods: {
    async initRateLimit () {
      await this.$http({
        url: '/plan/rate_limit',
        type: 'GET',
      }).then((json) => {
        this.maxCount = json.data.plan.hosting_max_count
        this.currentCount = json.data.using.hosting_max_count
      })
    },
    onClose () {
      this.$emit('close')
    },
    async onSubmit () {
      this.isLoading = true
      const randContentId = this.$utils.string.generateRandContentId()
      // コードパーツ 未使用の画像を削除
      this.$store.commit('deleteCodePartUnUseImage', this.$store.getters.getSectionAll)
      const sections = await this.getReplacedUrlSections(randContentId, 'hosting')
      if (!sections) return
      this.createRawHTML(sections)
      await this.getContentSize()
      const saveJson = await this.$store.dispatch('savePreviewData')
      if (!saveJson || saveJson.status !== 200) return

      this.createRawHTML(sections)
      const formData = new FormData()
      formData.append('body', this.rawHTML)
      formData.append('randContentId', randContentId)
      this.mobileCSS = this.createMobileCSS()
      // モバイルスタイルCSS
      if (this.mobileCSS) formData.append('mobileCss', this.mobileCSS)
      // メール用CSS
      formData.append('headCss', this.createHeadCSS())
      // outlook CSS
      formData.append('outlookCss', this.createOutlookCSS())
      // noindex
      formData.append('flgSearchIndex', this.flgSearchIndex ? 1 : 0)
      const json = await this.$http({
        url: '/hosting/' + this.$route.params.id,
        type: 'POST',
        params: formData,
      })
      if (json && json.status === 200) {
        this.$store.commit('mergeMessagePopup', {
          isShow: true,
          isSuccess: true,
          title: 'WEB公開が完了しました',
          messages: [json.data.url],
        })
      }
      this.$emit('close')
    },
  },
  computed: {
    limitedRemainingCount () {
      const remainingCount = this.maxCount - this.currentCount
      return remainingCount <= 0 ? 0 : remainingCount
    }
  },
}
</script>

<style lang="scss" scoped>
.submit {
  font-size: 14px;
  border-radius: 5px;
  color: #fff;
  border: solid 1px #484848;
  background: #484848;
  &:hover {
    background: #484848;
    opacity: 0.8;
  }
  &:disabled {
    border: solid 1px #6c757d;
    background: #6c757d;
    opacity: 0.8;
    cursor: default;
  }
}
</style>
